import pushModel from "../../mixin/store/api/pushModel";
import fetchModels from "@/mixin/store/api/fetchModels";
import changeModel from "@/mixin/store/api/changeModel";
import fetchModel from "@/mixin/store/api/fetchModel";
import deleteModel from "@/mixin/store/api/deleteModel";

export default {
    actions: {
        pushInventory(context, data) {
            return pushModel(context, 'inventories', data)
        },
        makeSyncInventory(context, data) {
            return pushModel(context, 'inventories/sync', data)
        },
        fetchInventories(context, search) {
            return fetchModels(context, 'inventories?', search.page + '&order[id]=desc', 'updateInventories');
        },
        fetchInventoryDetails(context, inventoryId) {
            return fetchModel(context, 'inventories', inventoryId, 'updateInventoryDetails');
        },
        fetchInventory(context, inventoryId) {
            return fetchModel(context, 'inventories', inventoryId, 'updateInventory');
        },
        putInventory(context, data) {
            return changeModel(context, 'inventories/' + data.inventoryId, data, 'updateInventory')
        },
        deleteInventory(context, id) {
            return deleteModel(context, 'inventories', id)
        },
        setInventoryDetails(context, data) {
            context.commit('updateInventoryDetails', data)
        },
    },
    mutations: {
        updateInventories(state, data) {
            state.inventories = data
        },
        updateInventory(state, data) {
            state.inventory = data
        },
        updateInventoryDetails(state, data) {
            state.inventoryDetails = data
        }
    },
    state: {
        inventories: {
            models: [],
            totalItems: 0,
        },
        inventory: {
            id: null,
            productAmount: null,
            difference: null,
            deficit: null,
            profit: null,
            createdAt: null,
            inventoryItems: [],
            isSynced: false
        },
        inventoryDetails: {
            id: null,
            productAmount: null,
            difference: null,
            deficit: null,
            profit: null,
            createdAt: null,
            inventoryItems: [],
            isSynced: false
        }
    },
    getters: {
        getInventories(state) {
            return state.inventories.models
        },
        getInventoriesTotalCount(state) {
            return state.inventories.totalItems
        },
        getInventory(state) {
            return state.inventory
        },
        getInventoryDetails(state) {
            return state.inventoryDetails
        },
    },
}
